import React, { useState } from 'react';
import { Select } from 'antd';

const CustomSelect = ({
  options,
  value,
  onChange,
  mode,
  placeholder = 'Select...',
  style = {},
  ...rest
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      allowClear={true}
      mode={mode}
      style={{ width: '100%', ...style }}
      {...rest}
    >
      {options.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default CustomSelect;
